<!--Header-->
<app-navbar [logoType]="'staff'">
    <h2>{{'AGRI_INFO.ABOUT' | translate}}</h2>
</app-navbar>
<!--Page info-->
<div class="portal-area pt-100" *ngIf="abjAbout === true">
    <div class="container">
        <div class="d-flex flex-wrap-reverse justify-content-center test2" >
            <div class="w-50 responsive-width">
                <!--Title -->
                <h1>{{'AGRI_INFO.ABOUT' | translate}}</h1>
                <p class="test" [innerHTML]="'AGRI_INFO.ABOUT_AGRI_HTML' | translate"></p>
            </div>
            <div>
                <!-- Picture -->
                <img class="about-img pt-70 pl-25" src="assets/img/about-us/about-us.jpg" alt="Portal">
            </div>
        </div>
    </div>
</div>
<div class="portal-area pt-100" *ngIf="abjStaff === true">
    <div class="container">
        <div class="d-flex flex-wrap-reverse justify-content-center" >
            <div class="w-50 pt-70 responsive-width">
                <!--Title -->
                <h1>{{'AGRI_INFO.ABOUT' | translate}} Staff </h1>
                <p>{{'AGRI_INFO.AGRI_STAFF' | translate}}</p>
                <a class="simple-text-button" routerLink="/agentie-de-recrutare">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
            </div>
            <div>
                <!-- Picture -->
                <img class="about-img pl-25" src="assets/img/about-us/plant.jpeg" alt="Portal">
            </div>
        </div>
    </div>
</div>
<!--Page info-->
<div class="portal-area pt-100" *ngIf="abjSpecial === true">
    <div class="container">
        <div class="d-flex flex-wrap-reverse justify-content-center">
            <div class="w-50 pt-70 responsive-width">
                <!--Title -->
                <h1>{{'AGRI_INFO.ABOUT' | translate}} Specialisti</h1>
                <p class="mr-5">{{'AGRI_INFO.AGRI_SPECIALIST' | translate}}</p>
            </div>
            <div>
                <!-- Picture -->
                <img class="about-img" src="assets/img/about-us/agri-specialist.jpeg" alt="Portal">
            </div>
        </div>
    </div>
</div>
<!--Page info-->
<div class="portal-area pt-100" *ngIf="abjJunior === true">
    <div class="container">
        <div class="d-flex flex-wrap-reverse justify-content-center">
            <div class="w-50 pt-70 responsive-width">
                <!--Title -->
                <h1>{{'AGRI_INFO.ABOUT' | translate}} Junior</h1>
                <p class="mr-5">{{'AGRI_INFO.AGRI_JUNIOR' | translate}}</p>
            </div>
            <div>
                <!-- Picture -->
                <img class="about-img" src="assets/img/about-us/abj-staff.png" alt="Portal">
            </div>
        </div>
    </div>
</div>
<!--Banner Jobs-->
<div class="counter-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="text-center col-12 mt-20 mb-20">
                <!--Banner title-->
                <h2>{{'HOMEPAGE.AGRI_JOBS.TITLE' | translate}}</h2>
                <p>{{'HOMEPAGE.AGRI_JOBS.SUBTITLE' | translate}}</p>
            </div>
        </div>
        <!--Banner icons & counters-->
        <div class="row justify-content-center">
            <!--single icon & counter-->
            <!-- <div class="col-md-3">
                <div class="counter-item">
                   
                    <img class="counter-img" src="assets/img/home-1/icon-candidates.png">
                
                    <h3><span class="counter">TBD</span></h3>
                    
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.CANDIDATE_HTML' | translate"></p>
                </div>
            </div> -->

            <!--single icon & counter-->
            <div class="col-md-4">
                <div class="counter-item">
                    <!--single icon-->
                    <img class="counter-img" src="assets/img/home-1/icon-jobs.png">
                    <!--counter-->
                    <h3><span class="counter">{{totalJobs}}</span></h3>
                    <!--info counter-->
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.JOB_NUMBER_HTML' | translate"></p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-4">
                <div class="counter-item">
                    <!--single icon -->
                    <img class="counter-img" src="assets/img/home-1/icon-companies.png">
                    <!--counter-->
                    <h3><span class="counter">{{availableCompanies}}</span></h3>
                    <!--info counter-->
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.EMPOYERS_HTML' | translate"></p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-4">
                <div class="counter-item">
                    <!--single icon -->
                    <img class="counter-img" src="assets/img/home-1/icon-years.png">
                    <!--counter-->
                    <h3><span class="counter">{{yearsOfActivity}}</span></h3>
                    <!--info counter-->
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.EXPERIANCE_HTML' | translate"></p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--pictures & info-->
<div class="info-area white-background">
    <div class="container-fluid overflow-hidden">
        <div class="row info-row pt-100 info-row-1">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7">
                    <h3>ABJ Staff</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.HTML_STAFF' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a *ngIf="!abjStaff" class="simple-text-button" routerLink="/abj-staff">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 info-row-2">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7 offset-md-5">
                    <h3>ABJ Specialiști</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.HTML_SPECIALIST' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a *ngIf="!abjSpecial" routerLink="/abj-specialisti" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 pb-100 info-row-3">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7">
                    <h3>ABJ Junior</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.HTML_JUNIOR' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a *ngIf="!abjJunior" routerLink="/abj-juniori"  class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner Domains-->
<div class="counter-area pt-70 pb-70">
    <div class="container">
        <!--domains title & info-->
        <div class="row justify-content-center">
            <div class="text-center col-12 mt-20 mb-10">
                <h2>{{'HOMEPAGE.AGRI_DOMAINS.TITLE' | translate}}</h2>
                <p [innerHTML]="'HOMEPAGE.AGRI_DOMAINS.SUBTITLE_HTML' | translate"></p>
            </div>
        </div>
        <!--domains icons & counters-->
        <div class="row pb-20">
            <!--domain single icon & counter -->
            <div class="col c-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="icofont-tractor job-cat-img"></i>
                    <!--info & counter-->
                    <h2>Agricultură</h2>
                    <p>({{agriJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>

                </div>
            </div>
            <!--domain single icon & counter -->
            <div class="col c-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="icofont-cabbage job-cat-img"></i>
                    <!--info & counter-->
                    <h2>Horticultură</h2>
                    <p>({{hortiJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col c-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="icofont-cow job-cat-img"></i>
                    <!--info & counter-->
                    <h2>Zootehnie</h2>
                    <p>({{zooJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col c-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="icofont-injection-syringe job-cat-img"></i>
                    <!--info & counter-->
                    <h2>Medicina veterinara</h2>
                    <p>({{medicVetJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col c-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="icofont-bread job-cat-img"></i>
                    <!--info & counter-->
                    <h2>Industia alimentara</h2>
                    <p>({{alimentsJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>
        </div>
        <!--button more jobs-->
        <div class="text-center col-12 pb-10">
            <a routerLink="/joburi" class="green-button">{{'HOMEPAGE.JOB_SEARCH.BUTTON' | translate}}</a>
        </div>

    </div>
</div>
<!--Bottom pictures-->
<div class="picture-area">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- left picture-->
                <div class="row">
                    <div class="col">
                        <!-- left picture info-->
                        <div class="pictureLeft">
                            <h2>{{'HOMEPAGE.EMPLOYEE_SEARCH.TITLE' | translate}}</h2>
                            <p [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.SUBTITLE_HTML2' | translate"></p>
                            <a routerLink="/servicii-agri-jobs" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>

                        </div>
                    </div>
                    <!-- right picture-->
                    <div class="col">
                        <!-- right picture info-->
                        <div class="pictureRight">
                            <h2>{{'HOMEPAGE.JOB_SEARCH.TITLE' | translate}}</h2>
                            <p [innerHTML]="'HOMEPAGE.JOB_SEARCH.SUBTITLE_HTML2' | translate"></p>
                            <a routerLink="/joburi" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
